<template>
  <!--
    width="8" height="8" - Pequeno
    width="16" height="16" - Medio
    width="24" height="24" - Grande
  -->
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
    <path d="M6.75,5h-.5A.25.25,0,0,0,6,5.25V7H1V2H3.25a.25.25,0,0,0,.25-.25v-.5A.25.25,0,0,0,3.25,1H.75A.75.75,0,0,0,0,1.75v5.5A.75.75,0,0,0,.75,8h5.5A.75.75,0,0,0,7,7.25H7v-2A.25.25,0,0,0,6.75,5Zm.875-5h-2a.376.376,0,0,0-.266.641l.558.558L2.109,5.006a.375.375,0,0,0,0,.53h0l.354.354a.375.375,0,0,0,.53,0h0L6.8,2.083l.558.557A.376.376,0,0,0,8,2.375v-2A.375.375,0,0,0,7.625,0Z" class="fill-current"/>
  </svg>
</template>
